// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import ScrollToTop from "./components/scroll-to-top";
import { StyledChart } from "./components/chart";
import LoginPage from "./pages/LoginPage";

// ----------------------------------------------------------------------

export default function App() {
  //localStorage.removeItem("token");
  const token = localStorage.getItem("token");
  if (!token) {
    return (
      <ThemeProvider>
        <LoginPage />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <Router />
    </ThemeProvider>
  );
}
